import React from 'react'

import Field from '../../../../../1stlog-ui/src/components/Field'
import Select from '../../../../../1stlog-ui/src/components/Select'

const SortSelect = (props) => {
  const {} = props

  const options = {
    creationTime: i18n.t('creation_time', 'Erstellungszeit'),
    receiverZip: i18n.t('receiver_zip', 'Empfänger PLZ'),
  }

  return (
    <Field name="sortBy" label={i18n.t('sorting', 'Sortierung')}>
      <Select direct options={options} />
    </Field>
  )
}

export default SortSelect
